import React, { Fragment, useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
//import Button from '@material-ui/core/Button';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import NotesReactTable from './NotesReactTable';
import { Row, Col, Button } from 'reactstrap'
import moment from 'moment';
import TextField from '@material-ui/core/TextField';

const NotesAdmission = ({ data, openNote, setOpenNote }) => {
  const [note, setNote] = useState("");
  const [dataTable, setData] = useState([]); //{ id: "1", usuario: "admin", fecha: moment(new Date()).format('YYYY/MM/DD'), nota: "nota nueva", hora: moment(new Date()).format("HH:MM a") }
  const [load, setLoad] = useState(false);
  const [loading, setLoading] = useState(true);
  const userProfile = sessionStorage.getItem('perfil');

  const reactTableData = {
    tableHeaderData: [{
      Header: 'id',
      accessor: 'id_nota',
      disableGlobalFilter: false,
      width: 65,
    },
    {
      Header: 'Usuario',
      accessor: 'nombre',
    },
    {
      Header: 'Nota',
      accessor: 'nota',
    },
    {
      Header: 'Fecha',
      accessor: 'fecha',
    },
    {
      Header: 'Hora',
      accessor: 'hora',
    }
    ],
    tableRowsData: dataTable
  };

  useEffect(() => {
    console.log("PROPSNOTES", data)
    let user = sessionStorage.getItem('usuario');
    let id_perfil = user.id_perfil;
    console.log("id_perfilUsuario", id_perfil)
    loadNotes(data);
  }, [note]);

  useEffect(() => {
    //console.log(dataTable);
  }, [dataTable, reactTableData.tableRowsData]);

  const filterData = (data) => {
    let orderData = data.filter(dat =>
      dat.id_perfil != 10 && dat.id_perfil != 16 &&
      dat.id_perfil != 20 && dat.id_perfil != 17
    );
    console.log("FILTERDATA", orderData)
    setData(orderData);
  }

  const loadNotes = (data) => {
    var data = {
      id_historia: parseInt(data.original.id_historia),
      id_admision: parseInt(data.original.id_admision)
    };

    fetch(process.env.REACT_APP_PUBLIC_URL + 'notas/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.existe) {
          console.log("NOTESLOADED", data);
          console.log(data.contenido[0]);
          if (data.contenido[0].notas != null) {
            if (sessionStorage.getItem('perfil') === '11') {
              filterData(data.contenido[0].notas.notas);
            } else {
              setData(data.contenido[0].notas.notas);
            }
            setLoad(true);
            setLoading(false);
          } else {
            setData([]);
            setLoad(false);
            setLoading(false);
          }
        } else {
          setData([]);
          setLoad(false);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const createNote = (data) => {

    if (note !== '') {
      var user = sessionStorage.getItem('usuario');
      user = JSON.parse(user);
      var data = {
        id_historia: data.original.id_historia.toString(),
        id_admision: data.original.id_admision.toString(),
        notas: {
          id_usuario: user.id_usuario,
          id_perfil: user.id_perfil,
          nota: note,
          fecha: moment(new Date()).format('YYYY/MM/DD'),
          hora: moment(new Date()).format('HH:MM A')
        }
      };
      console.log("DATASENDNOTE", data)
      fetch(process.env.REACT_APP_PUBLIC_URL + 'notas/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.text();
        })
        .then(res => {
          setNote("");
          alert(res);
          setLoad(false);
          data.notas.nombre = user.nombre;
          setData(prevdataTable => {
            console.log(prevdataTable);
            return [...prevdataTable, data.notas]
          });
          setLoad((preVload) => true);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    } else {
      alert("ingrese un valor de nota");
    }
  }

  return (<Fragment>
    {!loading ?
      <Modal
        open={openNote}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
          <div>
            <h5 className="bold-text">Observaciones
              {userProfile !== null && userProfile !== undefined ?
                userProfile == 10 ? ' Medicas' :
                  userProfile == 16 ? ' Tecnologo' :
                    userProfile == 11 ? ' de Recepción' :
                      userProfile == 17 ? ' Auxiliar' :
                        userProfile == 20 ? ' Transcriptor' : ''
                : null}
            </h5>
          </div>
          <h6>Datos basicos</h6>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ marginRight: 10 }}>{data.original.tip_documento}-{data.original.num_documento}</div>
            <div>{data.original.nombres !== null && data.original.nombres !== undefined ? data.original.nombres : data.original.fullname}</div>
          </div>
          <div className="form">
            <div className="form__form-group">
              <span className="form__form-group-label">Observación</span>
              <div className="form__form-group-field">
                <textarea
                  name="textarea-nota"
                  value={note}
                  onChange={(e) => {
                    console.log(e.target.value);
                    setNote(e.target.value)
                  }}
                >
                </textarea>
              </div>
              {load ? <Row style={{ height: 400 }}>
                <NotesReactTable reactTableData={reactTableData} />
              </Row> : null}

            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              style={{ marginTop: 10, marginRight: 10 }}
              color="primary"
              onClick={() => {
                createNote(data);
              }}
            >
              Aceptar
            </Button>
            <Button
              style={{ marginTop: 10 }}
              color="primary"
              onClick={() => {
                setOpenNote(false);
              }}
            >
              Cerrar
            </Button>
          </div>
        </div>
      </Modal> :
      <Modal
        open={loading}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div style={{
          position: 'absolute',
          backgroundColor: '#ffffff',
          width: 200,
          height: 200,
          backgroundColor: 'white',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          display: 'flex'
        }}
        >
          <div className="load__icon-wrap">
            <svg className="load__icon">
              <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
            </svg>
          </div>
        </div>
      </Modal>}
  </Fragment>)
}

export default reduxForm({
  form: `notes-admission-form`, // a unique identifier for this form
})(withTranslation('common')(NotesAdmission));